import React from 'react';
import {RootState} from "../../../../../../reducers";
import {getStoreConfig} from "../../../../../services/Store/reducer";
import {connect} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {getCart} from "../../../../../services/Cart/reducer";
import {DineInType} from "../../../../../services/Api/types";
import {ReactComponent as CounterIco} from "../../../../../../images/icons/counter.svg";
import {ReactComponent as BarcodeIco} from "../../../../../../images/icons/barcode.svg";
import {ReactComponent as TableIco} from "../../../../../../images/icons/table.svg";
import {ReactComponent as EditIco} from "../../../../../../images/icons/edit.svg";
import {getSession} from "../../../../../services/Session/reducer";
import {createKeyDownHandler} from "../../../../../utils/keyDownHanlder";
import {useSessionService} from "../../../../../services/Session/sessionService";
import ErrorFormAlertView from "../../../../Common/ErrorFormAlertView";
import CartCounterBanner from "../../CartCounterBanner";

interface OwnProps {
    setTableNumberModal: React.Dispatch<React.SetStateAction<boolean>>;
    errors: any[];
    options: DineInType[];
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps

const CartPageDineInSection = ({options, cart, setTableNumberModal, errors, session}: Props) => {
    const {t} = useTranslation();
    const sessionService = useSessionService();
    const table = cart.number;

    const isOptionVisible = (option: DineInType) => {
        if (options.length === 0) return false;

        if (!options.includes(option)) return false;

        if (options.length === 1) {
            return option !== DineInType.COUNTER;
        }

        return options.includes(option);
    }

    const isCounterOptionVisible = isOptionVisible(DineInType.COUNTER);
    const isTableOptionVisible = isOptionVisible(DineInType.TABLE);

    const onTableOptionChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        await sessionService.update({
            ...session,
            dine_in_type: event.target.value as DineInType,
        });
        setTableNumberModal(true);
    }

    const onCounterOptionChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        await sessionService.update({
            ...session,
            dine_in_type: event.target.value as DineInType,
            table_number: ""
        });
    }

    const handleOnLabelKeyDown = (type: DineInType.COUNTER | DineInType.TABLE) => createKeyDownHandler<HTMLLabelElement>({
        keys: ["Enter", " "],
        preventDefault: true,
        action: async () => {
            if (type === DineInType.COUNTER) {
                await sessionService.update({
                    ...session,
                    dine_in_type: type,
                    table_number: ""
                });
            } else {
                await sessionService.update({
                    ...session,
                    dine_in_type: type,
                });
                setTableNumberModal(true);
            }
        }
    });

    if (options.length === 1 && options[0] === DineInType.COUNTER) return (
        <div className="card-cart">
            <div className="container-fluid">
                <CartCounterBanner/>
            </div>
        </div>
    )

    return (
        <div className="card-cart card-cart-with-columns">
            <div className={"container-fluid"}>
                <h5 className={"card-cart-header"}>
                    {t("modules.cart.field.pickup_location.title")}
                </h5>
                <ErrorFormAlertView field="number" errors={errors}/>
                <div className={"card-cart-body"}>
                    <div className="btn-groups-columns">
                        <div className="btn-group-toggle btn-checks" data-toggle="buttons">
                            {
                                isCounterOptionVisible && (
                                    <label tabIndex={0} aria-checked={session.dine_in_type === DineInType.COUNTER}
                                           onKeyDown={handleOnLabelKeyDown(DineInType.COUNTER)}
                                           className={`btn btn-default btn-lg btn-check-full ${session.dine_in_type === DineInType.COUNTER ? " active" : ""}`}>
                                        <CounterIco/>
                                        <span>{t("enums.dine_in.type.COUNTER")}</span>
                                        <input className="btn-check1" type="radio" name="dine_in_type"
                                               value={DineInType.COUNTER}
                                               autoComplete="off"
                                               tabIndex={-1}
                                               checked={session.dine_in_type === DineInType.COUNTER}
                                               onChange={onCounterOptionChange}/>
                                    </label>
                                )
                            }
                            {
                                isTableOptionVisible && (
                                    <label tabIndex={0} aria-checked={session.dine_in_type === DineInType.TABLE}
                                           onKeyDown={handleOnLabelKeyDown(DineInType.TABLE)}
                                           className={`btn btn-default btn-lg btn-check-full ${session.dine_in_type === DineInType.TABLE ? " active" : ""}`}>
                                        <TableIco/>
                                        <span>
                                            <p className="mb-0">{t("enums.dine_in.type.TABLE")}</p>
                                            <small className={`${table ? " text-primary" : "text-muted"}`}>
                                                {!table ? t("modules.cart.action.scan_table_qr_code.title") : table}
                                            </small>
                                         </span>
                                        <input style={{width: session.dine_in_type === DineInType.TABLE ? 0 : "unset"}}
                                               className="btn-check1"
                                               type="radio"
                                               name="dine_in_type" value={DineInType.TABLE}
                                               autoComplete="off"
                                               tabIndex={-1}
                                               checked={session.dine_in_type === DineInType.TABLE}
                                               onClick={() => setTableNumberModal(true)}
                                               onChange={onTableOptionChange}/>
                                        {
                                            session.dine_in_type === DineInType.TABLE && !table && (
                                                <BarcodeIco className="text-primary mx-0"/>
                                            )
                                        }
                                        {
                                            session.dine_in_type === DineInType.TABLE && table && (
                                                <EditIco className="text-primary mx-0"/>
                                            )
                                        }
                                    </label>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
const mapStateToProps = (state: RootState) => ({
    config: getStoreConfig(state.config),
    cart: getCart(state.cart),
    session: getSession(state.session),
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(CartPageDineInSection));
